module.exports = __webpack_public_path__ + "static/media/UserCircle.0cecc8b4.svg";